import { Injectable, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { IAssetStatus, IDelegatedUsers, IDocumentView, IUserTraining } from "src/app/models";
import { RoutingService } from "src/app/services";
import { lastValueFrom } from "rxjs";
import { SitePersonTrainingView, SiteUserTrainingRequest } from "../models/training/sitePersonTrainingView";
import { SiteUserTrainings } from "../models/training/siteUserTrainings";
import { SiteUserCertificateRequest } from "../models/dashboard/siteView";
import { Response } from "../models/response";

@Injectable({
  providedIn: 'root'
})
export class TrainingService {
  private Training_URL = environment.triportTrainingService.url + environment.triportTrainingService.apiVersion;

  constructor(private http: HttpClient, private routeService: RoutingService) { }

  getUserTraininingList(sponsorName: string, portalId: number) {
    return new Promise<Array<IUserTraining>>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + `Training/${sponsorName}/${portalId}`)
        .toPromise()
        .then((platforms: Array<IUserTraining>) => {
          resolve(platforms);
        },
          (err) => {
            reject(err);
          });
    });
  }

  getScormUrl(AssetID: string, PersonId: string, AssetPortalId: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + 'Training/ScormUrl/' + AssetID + '/' + PersonId + '/' + AssetPortalId)
        .toPromise()
        .then((documentResponse: string) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }

  getDocumentUrl(sponsorName: string, portalId: number, MA_PersonAssetGUID: any, AssetID: number): Promise<IDocumentView> {
    return new Promise<IDocumentView>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + `Training/DocumentUrl/${sponsorName}/${portalId}/${MA_PersonAssetGUID}/${AssetID}`)
        .toPromise()
        .then((documentResponse: IDocumentView) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }
  getDownloadUrl(sponsorName: string, portalId: number, AssetID: number): Promise<IDocumentView> {
    return new Promise<IDocumentView>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + `Training/download/${sponsorName}/${portalId}/${AssetID}`)
        .toPromise()
        .then((documentResponse: IDocumentView) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }
  getStatus(sponsorName: string, portalId: number, MA_PersonAssetGUID: any): Promise<IUserTraining> {
    return new Promise<IUserTraining>((resolve, reject) => {
      this.http.get<IUserTraining>(this.Training_URL + `Training/Status/${sponsorName}/${portalId}/${MA_PersonAssetGUID}`)
        .toPromise()
        .then((documentResponse?: IUserTraining) => {
          resolve(documentResponse!);
        }, (err) => {
          reject(err);
        });
    });
  }

  getPrintCertificateUrl(sponsorName: string, portalId: number, MA_PersonAssetGUID: any): Promise<IDocumentView> {
    return new Promise<IDocumentView>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + `Training/Certificate/${sponsorName}/${portalId}/${MA_PersonAssetGUID}`)
        .toPromise()
        .then((documentResponse: IDocumentView) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }

  getPrintAllCertificateUrl(sponsorName: string, portalId: number): Promise<IDocumentView> {
    return new Promise<IDocumentView>((resolve, reject) => {
      this.http.get<any>(this.Training_URL + `Training/Certificate/${sponsorName}/${portalId}`)
        .toPromise()
        .then((documentResponse: IDocumentView) => {
          resolve(documentResponse);
        }, (err) => {
          reject(err);
        });
    });
  }

  PostEpaSignature(sponsorName: string, portalId: number, PersonAssetGUID: any) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.Training_URL + `Training/PostEpaSignature/${sponsorName}/${portalId}`, JSON.stringify(PersonAssetGUID))
        .toPromise()
        .then((response?: any) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });
    });
  }
  getSiteTrainingDetails(sponsorName: string, portalId: number, siteId: number) {
    return new Promise<SitePersonTrainingView>((resolve, reject) => {
      lastValueFrom(this.http.get<SitePersonTrainingView>(this.Training_URL + 'Training/SiteTrainingDetails/' + sponsorName + "/" + portalId + "/" + siteId))
        .then((response?: SitePersonTrainingView) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
  getSiteTrainingAssets(sponsorName: string, portalId: number, siteUserTrainingRequest: SiteUserTrainingRequest) {
    return new Promise<SiteUserTrainings>((resolve, reject) => {
      lastValueFrom(this.http.post<SiteUserTrainings>(this.Training_URL + 'Training/SiteTrainingAssets/' + sponsorName + "/" + portalId, siteUserTrainingRequest))
        .then((response?: SiteUserTrainings) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
  getSiteUserCertificates(sponsorName: string, portalId: number, siteUserCertificateRequest: SiteUserCertificateRequest) {
    return new Promise<IDocumentView>((resolve, reject) => {
      lastValueFrom(this.http.post<IDocumentView>(this.Training_URL + 'Training/SiteUserCertificate/' + sponsorName + "/" + portalId, siteUserCertificateRequest))
        .then((response?: IDocumentView) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }

  getRetrain(sponsorName: string, portalId: number, AssetId: number) {

    return new Promise<IUserTraining>((resolve, reject) => {
      lastValueFrom(this.http.get<IUserTraining>(this.Training_URL + `Training/ReTakeTraining/${sponsorName}/${portalId}/${AssetId}`))
        .then((response?: IUserTraining) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }

  getDelegatedUserDetails(sponsorName: string, portalId: number, assetId: number, userId: number) {
    return new Promise<IDelegatedUsers[]>((resolve, reject) => {
      lastValueFrom(this.http.get<IDelegatedUsers[]>(this.Training_URL + 'Training/GetDelegatedUserDetails/' + sponsorName + "/" + portalId + "/" + assetId + "/" + userId))
        .then((response?: IDelegatedUsers[]) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
  SaveAssetIsRequiredOrOptional(sponsorName: string, portalId: number, postData: any) {
    return new Promise<Response>((resolve, reject) => {
      lastValueFrom(this.http.post<Response>(this.Training_URL + 'Training/UpdateAssetRequiredStatus/' + sponsorName + "/" + portalId, postData))
        .then((response?: Response) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
  //TrainingListForAssignTraining/{sponsorName}/{portalId}/{userId}
  getTrainingListForAssignTraining(sponsorName: string, portalId: number, userId: number) {
    return new Promise<any[]>((resolve, reject) => {
      lastValueFrom(this.http.get<any[]>(this.Training_URL + 'Training/TrainingListForAssignTraining/' + sponsorName + "/" + portalId + "/" + userId))
        .then((response?: any[]) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
  UpdateDelegateUser(sponsorName: string, portalId: number, postData: any) {
    return new Promise<Response>((resolve, reject) => {
      lastValueFrom(this.http.post<Response>(this.Training_URL + 'Training/DelegateAsset/' + sponsorName + "/" + portalId, postData))
        .then((response?: Response) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }

  SaveTrainingAssignments(sponsorName: string, portalId: number, postData: any) {
    return new Promise<Response>((resolve, reject) => {
      lastValueFrom(this.http.post<Response>(this.Training_URL + 'Training/SaveTrainingAssignments/' + sponsorName + "/" + portalId, postData))
        .then((response?: Response) => {
          resolve(response!);
        },
          (err) => {
            reject(err);
          });

    });
  }
}
